export function className(name: string) {
  return name.toLowerCase().replace(/\s/g, "-");
}

export function titleCase(str: string) {
  return str.replace(/\w\S*/g, function(txt: string) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
}
